// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"61":"64749ab2","389":"c593439d","398":"b73d2bab","952":"935e8a7e"}[chunkId] + ".js";
};